import React from 'react';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom/cjs/react-router-dom.js';
import { useAccount } from '../context/accountContext.js';
import { getFileSize, i18nIntl, milesNumber } from '../../lib/ep.js';
import { useCSS } from '../../lib/hooks.js';

import SimpleEvolutionGraph from './SimpleEvolutionGraph.js';
import Tooltip from './Tooltip.js';

import Module from '../ui_items/Module.js';

const DashboardModuleWithGraph = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const parsed_data = [];
	let min = 100000000;
	let max = 0;

	(props?.module_data ?? []).map((point) => {
		const value = parseInt(point?.Total ?? '0');

		if(value < min) min = value;
		if(value > max) max = value;
		parsed_data.push(value);
	});

	const graph_id = props?.id ?? 'graph';
	const expected_factor = props?.expected_factor ?? 1;

	const _totals = props.data?.totals ?? false;

	const daysInMonth = () => {
		const date = new Date();
		const current_month = date.getMonth() + 1;
		const current_year = date.getFullYear();
		return new Date(current_year, current_month, 0).getDate();
	};

	const now = new Date();
	const actual_month_days_passed = now.getDate();
	const actual_month_name = `${now.toLocaleString(props.language, { month:'short' })} ${now.getFullYear()}`;

	now.setMonth(now.getMonth() - 1);
	const last_month_name = `${now.toLocaleString(props.language, { month:'short' })} ${now.getFullYear()}`;

	const actual_month_total = parseInt(_totals?.[graph_id] ?? 0);
	const prev_1_month_total = parseInt(_totals?.[`${graph_id}-1`] ?? 0);

	const section = props?.id ?? null;

	const actual_month_total_days = daysInMonth();
	const pending_month_days = actual_month_total_days - actual_month_days_passed;
	const average_per_day = actual_month_total / actual_month_days_passed;

	let expected_total_actual_month = Math.ceil(average_per_day * actual_month_total_days);
	if(expected_factor != 1) {
		expected_total_actual_month = actual_month_total + expected_factor * expected_total_actual_month;
	}

	return (
		<Module
			title={props.title}
			tooltip={<Tooltip
				position='top'
			>{props.description}</Tooltip>}
			icon={props.icon}
			actions={<Link
				to={`/${graph_id}`}
			>{i18n("View more")}</Link>}
		>
			<div class="gui_pos_rel">
				<div class="numeric_resumee">
					<div class="actual_month">
						<strong class="total">
							<strong>{(section != 'storage') ? milesNumber(actual_month_total,'0') : getFileSize(actual_month_total, 0, 'MB')}</strong>

							{/*(prev_1_month_percent) && (
								<span class="increment">
									{(actual_month_percent > 0) ? '+' : ''}{actual_month_percent}%
								</span>
							)*/}

							{/*(actual_month_total > 0 && isNotEmpty(props, 'units')) && (
								<span class="units">{props.units}</span>
							)*/}
						</strong>

						<span class="period_name">{actual_month_name}</span>
					</div>

					<div class="prev_month">
						<strong class="total">
							<strong>{(section != 'storage') ? milesNumber(prev_1_month_total, '0') : getFileSize(prev_1_month_total, 0, 'MB')}</strong>

							{/*(prev_1_month_percent) && (
								<span class="increment">
									{(prev_1_month_percent > 0) ? '+' : ''}{prev_1_month_percent}%
								</span>
							)*/}
						</strong>

						<span class="period_name">{last_month_name}</span>
					</div>
				</div>

				<div id={`simple_${graph_id}`} class="chart">
					<SimpleEvolutionGraph
						chart_id={graph_id}
						container={`#simple_${graph_id}`}
						data={parsed_data}
						color={props.color}
						min={0}
						max={Math.max(max, expected_total_actual_month)}
						use_gradient={false}
						use_perspective_points={false}
						perspective_growth={1.5}
						line_width={3}
						point_radius={4}
						expected={(expected_total_actual_month > 0 && pending_month_days > 3) ? expected_total_actual_month : null}
					/>
				</div>

				<Link
					to={`/${graph_id}`}
					class="is_fullscreen relative_to_container"
				/>
			</div>
		</Module>
	)
};

const DashboardWithGraphs = (props) => {
	useCSS('comp/charts.css');

	const { MyAccount } = useAccount();

	const language = MyAccount.getAgentLang();

	const modules = props?.modules ?? [];
	if(modules.length == 0) return null;

	const data = props?.data ?? {};

	return (
		<div class="graphic_dashboard">
			{modules.map((single_module) => {
				const module_data = data?.totals?.[`${single_module.id}-evolution`] ?? false;
				if(module_data === false || single_module.disabled) return null;

				return (
					<DashboardModuleWithGraph
						key={`graph_${single_module.id}`}
						{...single_module}
						{...module_data}
						data={data}
						module_data={module_data.data.graph_1.data}
						language={language}
						basepath={props.basepath}
						intl={props.intl}
					/>
				)
			})}
		</div>
	)
};

export default injectIntl(DashboardWithGraphs);